var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonaliseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "60px",
    viewBox: "0 0 64 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9F172AF6-A839-4F9E-BE45-1C0B52D961B2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-menu-copy",
    transform: "translate(-1038.000000, -516.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(811.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sliders-regular",
    transform: "translate(227.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,50 C0,51.6625 1.3375,53 3,53 L10.4625,53 C11.7375,57.0625 15.525,60 20,60 C24.475,60 28.2625,57.0625 29.5375,53 L61,53 C62.6625,53 64,51.6625 64,50 C64,48.3375 62.6625,47 61,47 L29.5375,47 C28.2625,42.9375 24.475,40 20,40 C15.525,40 11.7375,42.9375 10.4625,47 L3,47 C1.3375,47 0,48.3375 0,50 Z M16,50 C16,47.790861 17.790861,46 20,46 C22.209139,46 24,47.790861 24,50 C24,52.209139 22.209139,54 20,54 C17.790861,54 16,52.209139 16,50 Z M40,30 C40,27.790861 41.790861,26 44,26 C46.209139,26 48,27.790861 48,30 C48,32.209139 46.209139,34 44,34 C41.790861,34 40,32.209139 40,30 Z M44,20 C39.525,20 35.7375,22.9375 34.4625,27 L3,27 C1.3375,27 0,28.3375 0,30 C0,31.6625 1.3375,33 3,33 L34.4625,33 C35.7375,37.0625 39.525,40 44,40 C48.475,40 52.2625,37.0625 53.5375,33 L61,33 C62.6625,33 64,31.6625 64,30 C64,28.3375 62.6625,27 61,27 L53.5375,27 C52.2625,22.9375 48.475,20 44,20 Z M24,14 C21.790861,14 20,12.209139 20,10 C20,7.790861 21.790861,6 24,6 C26.209139,6 28,7.790861 28,10 C28,12.209139 26.209139,14 24,14 Z M33.5375,7 C32.2625,2.9375 28.475,0 24,0 C19.525,0 15.7375,2.9375 14.4625,7 L3,7 C1.3375,7 0,8.3375 0,10 C0,11.6625 1.3375,13 3,13 L14.4625,13 C15.7375,17.0625 19.525,20 24,20 C28.475,20 32.2625,17.0625 33.5375,13 L61,13 C62.6625,13 64,11.6625 64,10 C64,8.3375 62.6625,7 61,7 L33.5375,7 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonaliseIcon);
export default __webpack_public_path__ + "static/media/personaliseIcon.f1a131a9cfcd60bde6882a061ac07336.svg";
export { ForwardRef as ReactComponent };